import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Plus, ChevronRight, Bell } from 'lucide-react';
export function WorkspaceSelectPage() {
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5889">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-5890">
        <div className="flex flex-col items-center mb-8" data-id="element-5891">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5892">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5893">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5894"></div>
          </Link>
          <h1 className="text-2xl font-bold text-textMain mb-2" data-id="element-5895">
            Choose a workspace
          </h1>
          <p className="text-textMuted text-sm text-center" data-id="element-5896">
            Select a workspace to continue.
          </p>
        </div>

        <div className="space-y-3 mb-6" data-id="element-5897">
          <Link to="/app" className="block bg-surface border border-border rounded-xl p-4 hover:border-primary/50 transition-colors group" data-id="element-5898">
            <div className="flex items-center gap-4" data-id="element-5899">
              <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center text-primary font-bold text-lg shrink-0" data-id="element-5900">
                W
              </div>
              <div className="flex-1 min-w-0" data-id="element-5901">
                <div className="flex items-center gap-2 mb-1" data-id="element-5902">
                  <h3 className="font-semibold text-textMain truncate" data-id="element-5903">
                    The Wildwoods
                  </h3>
                  <span className="px-2 py-0.5 bg-background border border-border rounded text-[10px] font-medium text-textMuted uppercase tracking-wider" data-id="element-5904">
                    Artist
                  </span>
                </div>
                <p className="text-xs text-textMuted" data-id="element-5905">
                  Last opened 2 hours ago
                </p>
              </div>
              <div className="flex items-center gap-3 shrink-0" data-id="element-5906">
                <div className="flex items-center gap-1.5 px-2 py-1 bg-background rounded-md border border-border" data-id="element-5907">
                  <Bell className="w-3 h-3 text-textMuted" data-id="element-5908" />
                  <span className="text-xs font-bold" data-id="element-5909">3</span>
                </div>
                <ChevronRight className="w-5 h-5 text-textMuted group-hover:text-primary transition-colors" data-id="element-5910" />
              </div>
            </div>
          </Link>

          <Link to="/app" className="block bg-surface border border-border rounded-xl p-4 hover:border-primary/50 transition-colors group" data-id="element-5911">
            <div className="flex items-center gap-4" data-id="element-5912">
              <div className="w-12 h-12 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-500 font-bold text-lg shrink-0" data-id="element-5913">
                S
              </div>
              <div className="flex-1 min-w-0" data-id="element-5914">
                <div className="flex items-center gap-2 mb-1" data-id="element-5915">
                  <h3 className="font-semibold text-textMain truncate" data-id="element-5916">
                    Sarah & The Sundays
                  </h3>
                  <span className="px-2 py-0.5 bg-background border border-border rounded text-[10px] font-medium text-textMuted uppercase tracking-wider" data-id="element-5917">
                    Artist
                  </span>
                </div>
                <p className="text-xs text-textMuted" data-id="element-5918">Last opened yesterday</p>
              </div>
              <div className="flex items-center gap-3 shrink-0" data-id="element-5919">
                <ChevronRight className="w-5 h-5 text-textMuted group-hover:text-primary transition-colors" data-id="element-5920" />
              </div>
            </div>
          </Link>

          <Link to="/app" className="block bg-surface border border-border rounded-xl p-4 hover:border-primary/50 transition-colors group" data-id="element-5921">
            <div className="flex items-center gap-4" data-id="element-5922">
              <div className="w-12 h-12 rounded-lg bg-purple-500/20 flex items-center justify-center text-purple-500 font-bold text-lg shrink-0" data-id="element-5923">
                E
              </div>
              <div className="flex-1 min-w-0" data-id="element-5924">
                <div className="flex items-center gap-2 mb-1" data-id="element-5925">
                  <h3 className="font-semibold text-textMain truncate" data-id="element-5926">
                    The Empty Bottle
                  </h3>
                  <span className="px-2 py-0.5 bg-background border border-border rounded text-[10px] font-medium text-textMuted uppercase tracking-wider" data-id="element-5927">
                    Venue
                  </span>
                </div>
                <p className="text-xs text-textMuted" data-id="element-5928">Last opened 3 days ago</p>
              </div>
              <div className="flex items-center gap-3 shrink-0" data-id="element-5929">
                <ChevronRight className="w-5 h-5 text-textMuted group-hover:text-primary transition-colors" data-id="element-5930" />
              </div>
            </div>
          </Link>
        </div>

        <button className="w-full py-3 bg-transparent border border-dashed border-border rounded-xl text-sm font-medium text-textMuted hover:text-textMain hover:border-textMuted hover:bg-surface transition-colors flex items-center justify-center gap-2" data-id="element-5931">
          <Plus className="w-4 h-4" data-id="element-5932" />
          Create new workspace
        </button>
      </motion.div>
    </div>;
}